import { Link } from "react-router-dom";
import logo from "../../../../../images/MSG Notifier.svg";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-blue-white py-4 py-lg-5 px-3 px-md-4" >
      
      <div className="container border-bottom border-success-subtle pb-3 pb-lg-5" >
        <div className="row gy-4 d-flex align-items-center justify-content-between " style={{bottom: "90px"}}>
         
          <div className="col-12 col-lg-4 d-flex flex-column ">
            <div className="container py-2 font-inter ">
              <Link
                className="navbar-brand"
                to="/"
                onClick={() => window.scrollTo(0, 0)}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ height: "60px", width: "150px", objectFit: "cover" }}
                />
              </Link>
            </div>

            <p className="text-muted font-dmsans fs-6 lh-lg mt-3 mb-0">
              We are a Conversational Engagement Platform empowering businesses
              to engage meaningfully with customers across commerce, marketing
              and support use-cases on 30+ channels.
            </p>
          </div>

      
          <div className="col-12 col-lg-4 d-flex flex-column align-items-center text-center">
            <h6 className="fw-semibold mb-3">Features</h6>

            <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
              <li>
                <Link
                  to="/whatsApp_campaign"
                  className="text-dark text-decoration-none hover-yellowgreen"
                >
                 WhatsApp Campaign
                </Link>
              </li>
              <li>
                <Link
                  to="/audience_targeting"
                  className="text-dark text-decoration-none hover-yellowgreen"
                >
                 Audience Targeting
                </Link>
              </li>
              <li>
                <Link
                  to="/personalized_messages"
                  className="text-dark text-decoration-none hover-yellowgreen"
                >
                  Personalized Messages
                </Link>
              </li>
              <li>
                <Link
                  to="/automated_replies"
                  className="text-dark text-decoration-none hover-yellowgreen"
                >
                 Automated Replies
                </Link>
              </li>
            </ul>
          </div>

          {/* RIGHT */}
          <div className="col-12 col-lg-4 d-flex flex-column text-lg-center text-center">
            <h6 className="fw-semibold mb-3">Contact Us</h6>

            <p className="mb-1 fs-6">
              2nd Floor, Ithum,Tower, Sector 62, Noida, Uttar Pradesh – 201301
            </p>

            <p className="mb-1 fs-6">
              <a
                href="mailto:support@sendbulkmessage.com"
                className="text-dark text-decoration-none"
              >
                support@messagenotifier.com
              </a>
            </p>

            <p className="mb-3 fs-6">
              <a
                href="tel:+91 9910254756"
                className="text-dark text-decoration-none"
              >
                +91 9910254756
              </a>
            </p>

            <div className="d-flex justify-content-center justify-content-lg-center gap-3">
              {/* <a href="#" className="text-dark fs-5"> */}
                <FaFacebookF />
              {/* </a> */}
              {/* <a href="#" className="text-dark fs-5"> */}
                <FaInstagram />
              {/* </a> */}
              {/* <a href="#" className="text-dark fs-5"> */}
                <FaLinkedinIn />
              {/* </a> */}
              {/* <a href="#" className="text-dark fs-5"> */}
                <FaTwitter />
              {/* </a> */}
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM SECTION */}
      <div className="container pt-3 pt-lg-4">
        <div className="row align-items-center text-center text-sm-start">
          <div className="col-12 col-sm-6 mb-3 mb-sm-0">
            <p className="mb-0 text-dark font-dmsans fs-6">
              Message Notifier © 2024. All rights reserved.
            </p>
          </div>

          <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end gap-4">
            <Link
              to="/PrivacyPolicy"
              className="text-dark font-dmsans text-decoration-none footer-link hover-yellowgreen"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms&conditions"
              className="text-dark font-dmsans text-decoration-none footer-link hover-yellowgreen"
            >
              Terms & Condition
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
